// extracted by mini-css-extract-plugin
module.exports = {"root":"ScreenHeaderPusher_root"};